import { render, staticRenderFns } from "./MoblieIndex.vue?vue&type=template&id=afbf73ba"
import script from "./MoblieIndex.vue?vue&type=script&lang=js"
export * from "./MoblieIndex.vue?vue&type=script&lang=js"
import style0 from "./MoblieIndex.vue?vue&type=style&index=0&id=afbf73ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports